function ExpenseFilters({ products, categories, filters, onChange }) {
  return (
    <div className="filters-grid">
      <div className="form-group">
        <label className="form-label">Product</label>
        <select
          className="form-select"
          name="productId"
          value={filters.productId}
          onChange={onChange}
        >
          <option value="">All Products</option>
          {products.map(product => (
            <option key={product.id} value={product.id}>{product.name}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Category</label>
        <select
          className="form-select"
          name="category"
          value={filters.category}
          onChange={onChange}
        >
          <option value="">All Categories</option>
          {categories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Start Date</label>
        <input
          className="form-input"
          type="date"
          name="startDate"
          value={filters.startDate}
          onChange={onChange}
        />
      </div>

      <div className="form-group">
        <label className="form-label">End Date</label>
        <input
          className="form-input"
          type="date"
          name="endDate"
          value={filters.endDate}
          onChange={onChange}
        />
      </div>
    </div>
  )
}

export default ExpenseFilters
